var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMiddleAbdomen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "46px",
    height: "18px",
    viewBox: "0 0 51 18",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Middle Abdomen") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Humanuculus",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    fillOpacity: 0.195858829
  }, /*#__PURE__*/React.createElement("g", {
    id: "Artboard-Copy-38",
    transform: "translate(-190.000000, -155.000000)",
    fill: "#1E428A"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Front-Body---Selections",
    transform: "translate(175.074098, 42.681852)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.503241,112.318148 L62.6655102,112.318148 C63.3444312,116.375787 63.882645,119.375787 64.2801516,121.318148 C64.6776581,123.260509 65.1225103,126.260509 65.6147082,130.318148 L15.5698894,130.318148 L16.4252824,124.23169 L18.503241,112.318148 Z",
    id: "Middle-Abdomen"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMiddleAbdomen);
export default __webpack_public_path__ + "static/media/MiddleAbdomen.9d657c9b67e2899333d4e670b158add9.svg";
export { ForwardRef as ReactComponent };